import './styles.scss';

import React, {PropsWithChildren} from 'react';

import {AppLink} from '../ui';

export const ContactUsEmail = () => {
    return (
        <div className='contact-us-item email'>
            <h3 className='contact-us__title'>Email</h3>
            <p>Kashable LLC</p>
            <AppLink action='mailto-link' href='mailto:support@kashable.com'>support@kashable.com</AppLink>
        </div>
    );
};
export const ContactUsMail = () => {
    return (
        <div className='contact-us-item mail'>
            <h3 className='contact-us__title'>Mail</h3>
            <p>Kashable LLC</p>
            <p>PO Box 4287</p>
            <p>New York, NY 10163-4287</p>
        </div>
    );
};
export const ContactUs = ({children}: PropsWithChildren) => {
    return (
        <div className='contact-us'>
            <div className='contact-us-item'>{children}</div>
            <ContactUsEmail />
            <ContactUsMail />
        </div>
    );
};
